import $http from '../../../../../axios-instance';

/**
 * Obtener los consejos de prudencia Generales (P101 / P102 / P103) detalles del producto.
 *
 * @param Object commit
 * @param Object params: { languageId }
 */
export async function getGeneralsPrudenceTips({ commit }, params) {
    commit("dashboard/load", true, { root: true });
    try {
        const { data: response } = await $http.get(`/products/sga2/generals-prudence-tips`, { params });
        commit("setGeneralsPrudenceTips", response.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}


/**
 * Obtener los tipos de consejos de prudencia - asociados al producto. 
 * 
 * Categorías de Frases P ( Prevención, Intervención, Almacenamiento, Eliminación ).
 *
 * @param Object commit
 * @param Object params: { productId, versionId, languageId }
 */
export async function getPrudenceTips({ commit }, params) {
    commit("dashboard/load", true, { root: true });
    commit("setPrudenceTips", []);
    try {
        const { data: response } = await $http.get(`/products/sga2/prudence-tips`, { params });
        commit("setPrudenceTips", response.data);
    } catch (error) {
        if (this.$vue.$alertErrorsCallback(error)) return;
        this.$vue.$alertError(error.message);
    } finally {
        commit("dashboard/load", false, { root: true });
    }
}